/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractRubric
 */
export interface ContractRubric {
    /**
     * 
     */
    title: string;
    /**
     * 
     */
    reimbursement_rate: number;
    /**
     * 
     */
    rubric: string;
    /**
     * 
     */
    sort_order: number;
}

/**
 * Check if a given object implements the ContractRubric interface.
 */
export function instanceOfContractRubric(value: object): value is ContractRubric {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('reimbursement_rate' in value) || value['reimbursement_rate'] === undefined) return false;
    if (!('rubric' in value) || value['rubric'] === undefined) return false;
    if (!('sort_order' in value) || value['sort_order'] === undefined) return false;
    return true;
}

export function ContractRubricFromJSON(json: any): ContractRubric {
    return ContractRubricFromJSONTyped(json, false);
}

export function ContractRubricFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractRubric {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'reimbursement_rate': json['reimbursement_rate'],
        'rubric': json['rubric'],
        'sort_order': json['sort_order'],
    };
}

export function ContractRubricToJSON(json: any): ContractRubric {
    return ContractRubricToJSONTyped(json, false);
}

export function ContractRubricToJSONTyped(value?: ContractRubric | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'reimbursement_rate': value['reimbursement_rate'],
        'rubric': value['rubric'],
        'sort_order': value['sort_order'],
    };
}

